// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"3a65a5ef","581":"dcc21805","701":"9931bfc4","843":"69b76ea9","888":"bf3fde7c"}[chunkId] + ".chunk.css";
};